import { render, staticRenderFns } from "./Datapoint.vue?vue&type=template&id=ebe0310a&scoped=true"
import script from "./Datapoint.vue?vue&type=script&lang=js"
export * from "./Datapoint.vue?vue&type=script&lang=js"
import style0 from "./Datapoint.vue?vue&type=style&index=0&id=ebe0310a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe0310a",
  null
  
)

export default component.exports